import i18next from 'i18next'

import { getErrorCodeMessage } from '@/utils/error'

export const SNAPSHOT_BILLING_MODE_CONFLICT = 250

export function getSnapshotShareResultCode(result: unknown): number | undefined {
  if (!result || typeof result !== 'object') return undefined

  // Support both the existing API envelope and the backend's err_code field.
  const response = result as { code?: number; err_code?: number }
  return response.err_code ?? response.code
}

export function getSnapshotShareErrorMessage(result: unknown): string {
  const code = getSnapshotShareResultCode(result)
  if (code === SNAPSHOT_BILLING_MODE_CONFLICT) {
    return i18next.t('teamSnapshot.share.billingModeConflict', {
      defaultValue:
        "This snapshot cannot be shared because its owner's snapshot billing mode differs from the team's shared storage billing mode.",
    })
  }

  if (code !== undefined && code !== 0) return getErrorCodeMessage(code)

  return i18next.t('teamSnapshot.share.error', { defaultValue: 'Failed to share snapshot' })
}
